import { Component, } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';

import { BaseComponent } from './core/components/base.component';
import { TranslationService } from './core/services/translate.service';
import { TranslationModule } from './shared/modules/translate/translate.module';
import { ScreenSizeNotSupportedComponent } from './shared/components/screen-size-not-supported/screen-size-not-supported.component';
import { TooltipService } from './shared/directives/tooltip/tooltip.service';
import { LocalStorage } from './core/helpers/localstorage.helper';
 
import { TimeagoModule } from 'ngx-timeago';
import { ThemeService } from './core/services/theme.service';
 

@Component({
    selector: 'berry-root',
    standalone: true,
    imports: [CommonModule, TranslationModule, RouterOutlet, ScreenSizeNotSupportedComponent, TimeagoModule],
    providers: [],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class AppComponent extends BaseComponent {

    constructor(
        private tooltipService: TooltipService, private translationService: TranslationService, private themeService: ThemeService,
        ) {
        super();
        (document as any).loginByExternalToken = (auth: any, isDarkMode: boolean, lang: 'ar' | 'en') => {
            localStorage.setItem("auth", auth);
            LocalStorage.set('isMobile', true);
            LocalStorage.set('isDarkMode', isDarkMode);
            LocalStorage.set('lang', lang);
            location.reload();
        };

         (document as any).setDarkMode = ( isDarkMode: boolean) => {
            this.themeService.toggleDarkMode(isDarkMode)
        };
        
        (document as any).setAutomationIdClass = () => { document.documentElement.classList.add('automation-mode'); }

     

    }

    protected override ngSuperOnInit() {
        this.tooltipService.loadTooltip();
        this.loadTranslation();
        this.loadClientTheme();
        this.themeService.toggleDarkMode();
        LocalStorage.set('url', document.location.href.replace(document.baseURI, '/'), true);
        LocalStorage.set('tabId', Math.floor(Math.random() * 9999999) + 1, true);

        const urlParams = new URLSearchParams(window.location.search);
        const demoFromUrl = urlParams.get('demo');
        const demoInStorage = LocalStorage.get('demo');
        
        if (demoFromUrl === 'false') {
            LocalStorage.clear('demo');
        } else if (demoFromUrl === 'true') {
            LocalStorage.set('demo', 'true');
        }
        
        const demoRaw = LocalStorage.get('demo');
        const demoValue = demoRaw === 'true';
        
        const existingStyle = document.getElementById('demo-style');
        if (existingStyle) {
            existingStyle.remove();
        }
        
        if (demoValue) {
            const style = document.createElement('style');
            style.id = 'demo-style';
            style.textContent = `
                [data-sensitive] {
                    filter: blur(5px) !important;
                }
            `;
            document.head.appendChild(style);
        }
    }
    protected override ngSuperAfterViewInit() {
        if (LocalStorage.get('isMobile')) {
            document.documentElement.classList.add('mobile');
        }

    }
    protected override ngSuperOnDestroy() {

    }

    loadTranslation() {
        this.translationService.setLang(LocalStorage.get('lang') as 'ar' | 'en');
    }

    loadClientTheme() {           
      
        const faviconBase64 = this._appData.configurations.logoFavicon;

       
        const faviconElement = document.querySelector('link[rel="icon"]') as HTMLLinkElement;
        if (faviconElement) {
            faviconElement.href = faviconBase64.startsWith('data:image') ? faviconBase64 :  `data:image/png;base64,${faviconBase64}`;
        }
        const configurations = this._appData.configurations.systemThemes.RootTheme;
        this.themeService.generateRootTheme(configurations.baseColor, configurations.fontFamily, configurations.fontSize, configurations.spaceBase);
       
    }
}
